/* eslint-disable no-console */
import app, { Component } from 'apprun';
import { locations as objApi } from './api';
import { showSaveStatusMessage, lookup_en, isStringEqual } from './utils';

import PropEditorTextComponent from './common-props/common-props-text-edit';
import PropEditorAddressComponent from './common-props/common-props-address-edit';
import PropEditorPhoneComponent from './common-props/common-props-phone-edit';
import PropEditorSelectionComponent from './common-props/common-props-selection-edit';
import PropEditorRegionsComponent from './common-props/common-props-regions-edit';
import PropEditorDateComponent from './common-props/common-props-date-edit';
import PropEditorRegionSelectionComponent from './location-props/location-props-region-selection-edit';
import PropContractOptionComponent from './location-props/location-props-contract-option';
import UserPropertySocNetComponent from './user-props/user-props-socialNetworking';
import UserPropertyPhotoComponent from './user-props/user-props-photo';

const objectTypeId = 2;

export default class LocationComponent extends Component {
  getItemValue(item) {
    if (!item) {return;}
    let itemValue = item.value;
    let selectOptions;
    switch (item.fieldType) {
    case null:
    case 'CALL':
    case 'Text':
      return itemValue;
    case 'Phones':
    case 'html':
      return item.value
        ? item.value.split('<BR/>').map(p => (
          <span>
            {p}
            <br />
          </span>
        ))
        : '';
    case 'DateStr':
      return item.value ? new Date(item.value).toDateString() : null;
    case 'Int':
      if (itemValue === '-1' && item.fieldTypeDetail) {itemValue = 'Not Available';}
      return itemValue;
    case 'Selection':
      if (item.fieldTypeDetail && item.fieldTypeDetail.startsWith('[')) {
        selectOptions = JSON.parse(item.fieldTypeDetail);
      } else {
        selectOptions = lookup_en[item.fieldTypeDetail];
      }
      selectOptions = selectOptions || [];
      const selectedOption = selectOptions.find((p) => {
        return isStringEqual(p.id, itemValue);
      });

      itemValue = selectedOption ? selectedOption.value : item.value;
      return itemValue;
    case 'RegionSelection':
      selectOptions = lookup_en[item.fieldTypeDetail];
      selectOptions = selectOptions || [];
      const regionSelectedOption = selectOptions.find((p) => {
        return isStringEqual(p.id, itemValue);
      });

      itemValue = regionSelectedOption ? regionSelectedOption.value : item.value;
      if (itemValue.indexOf('-') >= 0) {
        itemValue = itemValue.substr(0, itemValue.indexOf('-'));
      }

      return itemValue;

    case 'ContractOption':
      selectOptions = lookup_en[item.fieldTypeDetail];
      selectOptions = selectOptions || [];
      const contractOption = selectOptions.find((p) => {
        return isStringEqual(p.id, itemValue);
      });

      itemValue = contractOption ? contractOption.value : item.value;

      return itemValue;
    case 'Award':
      return itemValue.replace(' >> ', ' ');
    case 'Regions':
      return itemValue.map(p => (
        <span>
          {p.regionsServicedName}
          <br />
        </span>
      ));
    default:
      return itemValue;
    }
  }

  Item = ({ item, editing }) => {
    if (!item || !item.displayOrder) {return;}
    return (
      <td>
        <label class="control-label col-sm-5">
          {item.dispName}{' '}
          {item.editable ? (
            ''
          ) : (
            <span>
              &nbsp;
              <i class="fa fa-lock" />
            </span>
          )}
        </label>
        <div class="form-text col-sm-5">{this.getItemValue(item)}</div>
        <div class="col-sm-2 text-right">
          {editing ? <i class="control-label glyphicon glyphicon-pencil" /> : ''}
        </div>
      </td>
    );
  };

  List = ({ state }) => (
    <table id="tblProp" class="table table-striped table-condensed table-bordered table-hover">
      <tbody>
        {state.props
          .filter(p => p.fieldType === 'Group' || p.dispName.toUpperCase().indexOf(state.filter.toUpperCase()) >= 0)
          .map((item) => {
            return (
              <tr
                style={{ display: 'table-row' }}
                data-displayOrder={item.displayOrder}
                onclick={(e) => {
                  if (item.fieldType !== 'Group') {this.run('edit-prop', item, e);}
                }}>
                <this.Item item={item} editing={state.editingItem && item.fieldName === state.editingItem.fieldName} />
              </tr>
            );
          })}
      </tbody>
    </table>
  );

  Photo = ({ state }) => (
    <div class="col-md-12">
      <img
        id="usrImage"
        src={state.imageFailed?'/images/imageComingSoon.jpg':`${window['defaultBasePath']}/location/photo/${state.locationId}`}
        style={{ width: '100%', height: '100%' }}
        onerror={() => this.run('image-failed')}
        onclick={e => this.run('edit-photo', e)}
      />
    </div>
  );

  state = { filter: '', editingItem: null, props:[] };

  // prettier-ignore
  view = (state) => {
    if (!state || !state.location || !state.props) {return;}
    return (
      <div>
        <div class="row" style={{ width: '500px' }}>
          <this.Photo state={state} />
          <br/>
        </div>
        <div class="row">
          <br/>
          <button onclick={() => this.run('start-jumpSync')} disabled={(this.getItem('ForceSyncButton') || {}).editable?'':'disabled'}>Jump Sync</button>
        </div>
        <div class="list-group" style={{ width: '500px' }}>
          <div style={{ 'white-space': 'normal', 'word-wrap': 'break-word' }}>
            <this.List state={state} />
          </div>
          <a class="row list-group-item" href={`#user-list/0/${state.locationId}/users`}>
            Users<span class="badge">{(this.getItem('UsersCount') || {}).value}</span>
          </a>
        </div>
      </div>
    );
  }

  update = {
    refresh: async (state, locationId) => {
      state.imageFailed = false;
      const location = await objApi.getProperties(locationId);
      const hasFullAccess = location.hasFullAccess;

      state.props = location.locationDetail;
      state.props.sort(function (a, b) {
        return a.orderA2Z - b.orderA2Z;
      });
      state.props.forEach(item => (item.displayOrder = item.orderA2Z));

      return { ...state, locationId, location, editingItem: null, hasFullAccess };
    },

    'edit-prop': (state, item, e) => {
      if (!item.editable) {return;}
      e.preventDefault();
      state.editingItem = item;

      const panelId = 'prop-edit-' + item.fieldType;

      let editorState = {
        item,
        panelId,
        caller: this,
        cancel: 'edit-prop-cancel',
        save: 'save-prop',
        delete: 'delete-prop',
        addressId: 0,
        objectTypeId: 0,
        phoneId: 0,
        extra:{},
      };

      let comp;
      switch (item.fieldType) {
      case 'Address':
        comp = PropEditorAddressComponent;
        editorState = { ...editorState, addressId: state.locationId, objectTypeId };
        break;
      case 'Phones':
        comp = PropEditorPhoneComponent;
        editorState = { ...editorState, phoneId: state.locationId, objectTypeId };
        break;
      case 'Selection':
        comp = PropEditorSelectionComponent;
        break;
      case 'RegionSelection':
        comp = PropEditorRegionSelectionComponent;
        break;
      case 'ContractOption':
        comp = PropContractOptionComponent;
        break;
      case 'DateStr':
        comp = PropEditorDateComponent;
        break;
      case 'Regions':
        comp = PropEditorRegionsComponent;
        const provCt = state.location.locationDetail.find(p => p.fieldName === 'ProvStateCt').value;
        const prov =  lookup_en.ProvStateCt.find(p => p.id === provCt).value;
        editorState.extra = { province: prov };
        break;
      case 'SocNet':
        comp = UserPropertySocNetComponent;
        break;
      case 'Photo':
        comp = UserPropertyPhotoComponent;
        break;
      default:
        comp = PropEditorTextComponent;
        break;
      }

      app.run('#add-panel', { id: panelId, title: item.dispName, Component: comp, state: editorState, level: 4 });
    },

    'save-prop': async (state, item, panelId, newVal) => {
      try{
        if (panelId === 'prop-edit-Address' || panelId === 'prop-edit-Phones') {
          this.run('edit-prop-cancel', panelId);
          this.run('refresh', state.locationId);
        } else if (panelId === 'prop-edit-Regions') {
          if (await objApi.postLocationAreas(state.locationId, newVal)) {
          //state.locationId = newVal;
            this.run('edit-prop-cancel', panelId);
            showSaveStatusMessage('location');
            this.run('refresh', state.locationId);
          }
        } else {
          console.log(newVal);
          const result = await objApi.upsertProperty(state.locationId, { prop: item, newValue: newVal });
          showSaveStatusMessage((result===1)?'location':null);
          if (result) {
            item.value = newVal;
            this.run('edit-prop-cancel', panelId);
          }
        }
      }catch{showSaveStatusMessage();}
      return state;
    },

    'delete-prop': async (state, item, panelId) => {
      try {
        if(
          (item.fieldType==='SocNet') ||
          (item.fieldType==='Photo')
        ) {
          const results = await objApi.deleteProperty(state.locationId, item);
          showSaveStatusMessage((results===1)?'location':null);
          this.run('refresh', state.locationId);
        }
        this.run('edit-prop-cancel', panelId);
      } catch {
        showSaveStatusMessage();
      }
    },

    'edit-prop-cancel': (state, id) => {
      state.editingItem = null;
      app.run('#clear-panel', id);
      return state;
    },

    'image-failed': (state) => {
      if (!state.imageFailed) {return { ...state, imageFailed: true };}
    },

    'edit-photo': (state, e) => {
      console.log('In edit-photo......');
      const item = { ...this.getItem('Photo'), value: e.target.src };
      console.log(item);
      this.run('edit-prop', item, e);
    },

    'start-jumpSync': async (state) => {
      await objApi.initiateForceSync(state.locationId);
      showSaveStatusMessage('Jump Sync');
    },
  };

  getItem = fieldName => this.state.props.find(p => p.fieldName === fieldName);

  mounted = ({ state }) => {
    this.run('refresh', state.locationId);
  };
}
